export default __webpack_public_path__ + "static/media/17_SchererGruppe-DTM-Documentary-EschweilerPhotography_21A4009.17cabbfc.jpg";